import { render, staticRenderFns } from "./FoldersList.vue?vue&type=template&id=9098f3e0&scoped=true"
import script from "./FoldersList.vue?vue&type=script&lang=js"
export * from "./FoldersList.vue?vue&type=script&lang=js"
import style0 from "./FoldersList.vue?vue&type=style&index=0&id=9098f3e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9098f3e0",
  null
  
)

export default component.exports